import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import Button from '@atlaskit/button/new';
import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import WorldIcon from '@atlaskit/icon/core/migration/globe--world';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { i18nShared } from './i18nShared';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const UpdateSplitContainer = styled.div`
	display: flex;
	position: relative;
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const VerticalSeparator = styled.div`
	width: 1px;
	background-color: ${token('color.background.input', N0)};
`;

const leftButtonTheme = (currentTheme, themeProps) => {
	const { buttonStyles, spinnerStyles } = currentTheme(themeProps);
	return {
		buttonStyles: {
			...buttonStyles,
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			marginRight: 0,
		},
		spinnerStyles,
	};
};

const rightButtonTheme = (currentTheme, themeProps) => {
	const { buttonStyles, spinnerStyles } = currentTheme(themeProps);
	return {
		buttonStyles: {
			...buttonStyles,
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			marginLeft: 0,
		},
		spinnerStyles,
	};
};

export type Props = {
	publishButtonDisabled: boolean | undefined;
	isUnpublishedDraft: boolean;
	shouldShowWorldIcon: boolean;
};

export const PlaceholderPublishButton = ({
	publishButtonDisabled,
	isUnpublishedDraft,
	shouldShowWorldIcon,
}: Props) => {
	const intl = useIntl();

	if (!isUnpublishedDraft) {
		return (
			<UpdateSplitContainer>
				<CustomThemeButton
					appearance="primary"
					theme={leftButtonTheme}
					isDisabled={publishButtonDisabled}
					iconBefore={
						shouldShowWorldIcon ? (
							<WorldIcon
								spacing="spacious"
								label={intl.formatMessage(i18nShared.updatePublicContentLabel)}
							/>
						) : undefined
					}
				>
					{intl.formatMessage(i18nShared.updateButton)}
				</CustomThemeButton>
				<VerticalSeparator />
				<CustomThemeButton
					appearance="primary"
					iconAfter={
						<ChevronDownIcon
							label={intl.formatMessage(i18nShared.chevronButtonTooltip)}
							LEGACY_size="medium"
						/>
					}
					theme={rightButtonTheme}
					isDisabled={publishButtonDisabled}
				/>
			</UpdateSplitContainer>
		);
	} else {
		return (
			<Button appearance="primary" isDisabled={publishButtonDisabled}>
				<FormattedMessage {...i18nShared.publishButton} />
			</Button>
		);
	}
};
